import { Check } from "lucide-react";

export const WIZARD_STEPS = ["Video", "Title", "Items", "Design", "Preview", "Shipping", "Pay"];

export const Stepper = ({ step, maxStep, onJump, skip = 0 }) => (
  <nav aria-label="Progress" data-testid="wizard-stepper">
    <div className="h-3 overflow-hidden rounded-full bg-[#E6DEC6]">
      <div className="h-full rounded-full bg-[#A83232] transition-[width] duration-500" style={{ width: `${(step / WIZARD_STEPS.length) * 100}%` }} data-testid="wizard-progress-bar" />
    </div>
    <ol className="mt-4 grid grid-cols-7 gap-0.5">
      {WIZARD_STEPS.map((label, i) => {
        const n = i + 1;
        const skipped = n === skip;
        const done = n < step && !skipped;
        const reachable = n <= maxStep && !skipped;
        return (
          <li key={label}>
            <button
              type="button"
              disabled={!reachable}
              onClick={() => onJump(n)}
              className="flex w-full flex-col items-center gap-1 disabled:cursor-not-allowed"
              data-testid={`wizard-step-indicator-${n}`}
              aria-current={n === step ? "step" : undefined}
            >
              <span className={`flex h-9 w-9 items-center sm:h-10 sm:w-10 justify-center rounded-full border-2 text-lg font-bold transition-colors ${n === step ? "border-[#A83232] bg-[#A83232] text-white" : done ? "border-[#2E6930] bg-[#2E6930] text-white" : "border-[#E6DEC6] bg-white text-[#8C7A6B]"}`}>
                {done ? <Check size={20} /> : n}
              </span>
              <span className={`text-[11px] font-semibold sm:text-sm ${n === step ? "text-[#A83232]" : "text-[#5C4A3E]"} ${skipped ? "line-through opacity-60" : ""}`}>{label}</span>
            </button>
          </li>
        );
      })}
    </ol>
  </nav>
);

export const StepNav = ({ back, next, nextLabel = "Continue", disabled, busy, testid = "wizard-next-button" }) => (
  <div className="mt-10 flex flex-col-reverse gap-3 sm:flex-row sm:justify-between">
    {back ? <button type="button" className="btn-secondary" onClick={back} data-testid="wizard-back-button">Back</button> : <span />}
    <button type="button" className="btn-primary sm:min-w-[220px]" onClick={next} disabled={disabled || busy} data-testid={testid}>{busy ? "Saving..." : nextLabel}</button>
  </div>
);

export const BigCheck = ({ checked, onChange, children, testid }) => (
  <label className={`flex cursor-pointer gap-4 rounded-xl border-2 p-4 transition-colors ${checked ? "border-[#2E6930] bg-[#F1F7F1]" : "border-[#E6DEC6] bg-white"}`}>
    <input type="checkbox" className="mt-1 h-7 w-7 shrink-0 accent-[#A83232]" checked={!!checked} onChange={(e) => onChange(e.target.checked)} data-testid={testid} />
    <span className="text-lg leading-relaxed text-[#2C1E16]">{children}</span>
  </label>
);
